<template>
    <component :is="interactComponent" :message="message" :code="room_code" :config="config"/>
</template>

<script>
    import rooms from '../../services/rooms';
    import Kit1Interact from "../../kits/1/interact.vue";

    export default {
        name: 'interact',
        props: ['room_code'],
        components: {Kit1Interact},
        data: function() {
            return {
                interactComponent: null,
                config: {}
            }
        },
        computed: {
            identity: function () {
                return this.$store.state.socket.identity;
            },
            message: function () {
                return this.$store.state.socket.message;
            }
        },
        watch: {
            identity(identity) {
                console.log('Socket: Setting type as interact.');
                this.$socket.sendObj({cmd: 'handshake', data: {type: 'interact', room_code: this.room_code}, identity: identity});
                this.$store.commit('setSocketType', 'interact');
            },
            message(payload) {
                switch (payload.cmd) {
                    case 'room':
                        this.config = payload.data.config;
                        break;
                }
            }
        },
        asyncComputed: {
            room: function() {
                return rooms.getRoomByCode(this.room_code).then(room => {
                    this.interactComponent = 'kit' + room.kit_id + '-interact';
                    return room;
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/interact/interact.vue